import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./../../css/online-store.scss";
import "react-multi-carousel/lib/styles.css";
import Techstacks from "./../../component/techstacks";

import mobileapp11x from "./../../images/mobileapp/mobileapp-1-1x.png";
import mobileapp12x from "./../../images/mobileapp/mobileapp-1-2x.png";
import mobileapp21x from "./../../images/mobileapp/mobileapp-2-1x.png";
import mobileapp22x from "./../../images/mobileapp/mobileapp-2-2x.png";
import mobileapp31x from "./../../images/mobileapp/mobileapp-3-1x.png";
import mobileapp32x from "./../../images/mobileapp/mobileapp-3-2x.png";
import mobileapp41x from "./../../images/mobileapp/mobileapp-4-1x.png";
import mobileapp42x from "./../../images/mobileapp/mobileapp-4-2x.png";
import mobileapp51x from "./../../images/mobileapp/mobileapp-5-1x.png";
import mobileapp52x from "./../../images/mobileapp/mobileapp-5-2x.png";

import imgNumber1 from "./../../img/imgNumber1.svg";
import imgNumber2 from "./../../img/imgNumber2.svg";
import imgNumber3 from "./../../img/imgNumber3.svg";
import imgNumber4 from "./../../img/imgNumber4.svg";
import imgNumber5 from "./../../img/imgNumber5.svg";
import imgConclusion from "./../../img/imgConclusion.svg";

function MobileApp(props) {

	const [mobileapp1WD, setMobileapp1WD] = useState('');
	const [mobileapp2WD, setMobileapp2WD] = useState('');
	const [mobileapp3WD, setMobileapp3WD] = useState('');
	const [mobileapp4WD, setMobileapp4WD] = useState('');
	const [mobileapp5WD, setMobileapp5WD] = useState('');
	
   useEffect(() => {
	  if( props.wd < 1200 ){
		  setMobileapp1WD(mobileapp11x);
		  setMobileapp2WD(mobileapp21x);
		  setMobileapp3WD(mobileapp31x);
		  setMobileapp4WD(mobileapp41x);
		  setMobileapp5WD(mobileapp51x);
	  } else if( props.wd >= 1200 ){
		  setMobileapp1WD(mobileapp12x);
		  setMobileapp2WD(mobileapp22x);
		  setMobileapp3WD(mobileapp32x);
		  setMobileapp4WD(mobileapp42x);
		  setMobileapp5WD(mobileapp52x);
	  }
   },[props.wd]);
  
  return (

      <div>
        <Container>
          <div className="wrapBG">
            <Row className="wrapRowMobileApp1">
              <Col xl="5" lg="5" md="12" sm="12">
                <h2 className="h2OnlineStore h2MobileApp1">
                  <span>Мобільний</span> додаток
                </h2>
                <p className="pOnlineStore">
                  Ми спеціалізуємося на створенні мобільних додатків, які спрощують та оптимізують процес страхування.
                </p>
                <a href="/ua/contact" className="btn buttonOne buttonProduct">Зв'язатися</a>
              </Col>
              <Col xl={{ span: 5, offset: 2 }} lg={{ span: 5, offset: 2 }} md="12" sm="12">
                <img src={mobileapp1WD} alt="" className="imgOnlineStore1" />
              </Col>
            </Row>
            <Row className="wrapRowMobileApp2">
              <Col xl="12" lg="12" md="12" sm="12">
                <h2 className="h2TechStacksText">Технічні стеки</h2>
              </Col>
            </Row>
            <Row className="wrapRowMobileApp3">
              <Col xl="12" lg="12" md="12" sm="12">
                <div id="marquee1" className="marquee">
                  <div id="blockSlider" className="marquee__inner">
                    <Techstacks />
                  </div>
                </div>
              </Col>
            </Row>
            <Row className="wrapRowDevelopmentProcessText">
              <Col xl="12" lg="12" md="12" sm="12">
                <h2 className="h2DevelopmentProcess">ЗАВДАННЯ КЛІЄНТА</h2>
              </Col>
            </Row>
            <Row className="wrapRowMobileApp4">
              <Col xl="7" lg="7" md="12" sm="12">
                <p className="pCustomerProblems">
                  Клієнт мав на меті створити мобільний додаток, який дозволив би страхувальникам отримувати доступ всіх своїх контрактів та їх статусу в страховій компанії. Додаток мав відображати наступні типи контрактів:
                  <br/>
                  <br/>
                  <b>- Договори страхування, придбані особисто:</b> договори, придбані в офісі страхової компанії.
                  <br/>
                  <b>- Онлайн-контракти страхування:</b> контракти, придбані через веб-сайт компанії за допомогою онлайн-каналів.
                  <br/>
                  <br/>
                    Клієнти очікували, що мобільний додаток надасть детальну інформацію в їх контрактах, зокрема:
                  <br/>
                  <b>- Тип страхування:</b> конкретне страхове покриття або тип полісу, пов'язаний з кожним контрактом.
                  <br/>
                  <b>- Номер договору страхування:</b> унікальний ідентифікатор для кожного договору страхування.
                  <br/>
                  <b>- Страхова програма:</b> деталі страхової програми або плану, пов'язаного з контрактом.
                  <br/>
                  <b>- Тривалість контракту:</b> період дії контракту.
                  <br/>
                  <b>- Контактна інформація:</b> контактні дані для зв'язку із страховою компанією.
                  <br/>
                </p>
                <br/>
                <p className="pCustomerProblems">
                  Ця вичерпна інформація дозволила б клієнтам швидко отримувати доступ до всіх своїх контрактів та уникнути потреби пошуку цих даних у фізичних документах чи електронних листах. Метою було надати зручну та централізовану платформу для управління договорами страхування та пов'язаною інформацією.
                </p>

              </Col>
              <Col xl="5" lg="5" md="12" sm="12">
                <img
                    src={mobileapp2WD}
                    alt=""
                    className="imgCustomerProblems1"
                />
              </Col>
            </Row>
            <Row className="wrapRowMobileApp5">
              <Col
                  xl="6"
                  lg="6"
                  md="12"
                  sm="12"
                  className="colImgCustomerProblems3Top"
              >
                <img
                    src={mobileapp3WD}
                    alt=""
                    className="imgCustomerProblems3"
                />
              </Col>
              <Col xl={{ offset: 1, span: 5 }} lg={{ offset: 1, span: 5 }} md="12" sm="12">
                <p className="pOnlineStore1">
                  Для досягнення мети клієнта з підтримки активності страхувальників онлайн та сприяння швидкому вирішенню проблем було розроблено мобільний додаток з наступними ключовими функціями:
                  <br/><br/>
                  <b>- Придбання страховки автомобіля в додатку:</b> клієнти мають можливість придбати автострахування безпосередньо у додатку. Після покупки угода автоматично з'являється в розділі "Контракти" мобільного додатку, забезпечуючи безперебійну та миттєву роботу.
                  <br/><br/>
                  <b>- Управління страховими договорами для сім'ї:</b> додаток дав можливість клієнтам додавати страхові контракти для своїх родичів та членів сім'ї до свого облікового запису. Після реєстрації ці родинні угоди включались до розділу "Контракти". Ця функція забезпечила зручне управління страховими контрактами для всієї родини та спростила процес для батьків.
                  <br/><br/>
                  <b>- Чат-підтримка в додатку:</b> клієнти мали доступ до чат-функції в додатку, що надавала зручну платформу для вирішення питань та отримання допомоги. Чат дав можливість клієнтам вибирати відповідну тему для їх запитань, таку як Медицина, Придбання полісу, Страхова подія та інші. Ця функція сприяла швидкому та ефективному вирішенню питань та зв'язку із страховою компанією.
                  <br/><br/>
                </p>
              </Col>
              <Col
                  xl="6"
                  lg="6"
                  md="12"
                  sm="12"
                  className="colImgCustomerProblems3Bottom"
              >
                <img
                    src={mobileapp3WD}
                    alt=""
                    className="imgCustomerProblems3"
                />
              </Col>
            </Row>
            <Row className="wrapRowMobileApp6">
              <Col xl="7" lg="7" md="12" sm="12">
                <p className="pCustomerProblems">
                  Процес реєстрації клієнтів у мобільному додатку оптимізували, зробивши акцент на простоті та зручності. Він включав два простих кроки:
                </p>
                <p className="pCustomerProblems">
                  <b>1. Надання особистої інформації:</b> клієнти мали ввести свій мобільний номер телефону та дату народження. Ця інформація слугувала основним ідентифікатором.
                  <br/>
                  <b>2. Перевірка одноразовим паролем:</b> після введення свого мобільного номеру та дати народження клієнти отримували одноразовий пароль на той самий номер телефону. Потім їм було запропоновано ввести цей пароль у відповідне поле для підтвердження.
                  <br/><br/>
                  Важливо відзначити, що якщо клієнти надавали неправильні мобільні номери телефонів або дати народження під час реєстрації, то додаток не відображав їх контракти. У таких випадках клієнтам рекомендувалося зв'язатися з фахівцем через чат у додатку для перевірки даних.
                </p>
                <p className="pCustomerProblems">
                  Мобільний додаток також містить кілька зручних налаштувань, зокрема:
                </p>
                <ul className="ulCustomerProblems">
                  <li><b>"Запам'ятати в системі":</b> ця функція дозволяла клієнтам активувати опцію, яка усуває потребу вводити одноразовий пароль кожен раз під час входу в додаток. При відкритті додатку клієнти могли відразу отримати доступ до своїх облікових записів та переглядати свої контракти.</li>
                  <li><b>"Клієнти, які додали ваші контракти":</b> ця функція показувала користувачам мобільного додатку, кому клієнт надав доступ до своїх контрактів. Клієнти мали можливість видаляти таких користувачів, забезпечуючи перегляд тільки своїх страхових контрактів.</li>
                  <li><b>"Клієнти, яких ви додали":</b> ця функція відображала контракти клієнтів, яких клієнт додав до свого облікового запису. Клієнти могли видаляти цих доданих клієнтів, забезпечуючи перегляд тільки своїх страхових контрактів. Ці функції спрямовані на підвищення приватності користувачів та надання чіткого уявлення про їх страхові угоди.</li>
                </ul>
              </Col>
              <Col xl="5" lg="5" md="12" sm="12">
                <img
                    src={mobileapp4WD}
                    alt=""
                    className="imgCustomerProblems3"
                />
              </Col>
            </Row>
            <Row className="wrapRowMobileApp7">
              <Col>
                <h2 className="h2OnlineStore1 h2MobileAppDP">ПРОЦЕС РОЗРОБКИ</h2>
              </Col>
            </Row>
            <Row className="wrapRowMobileApp8">
              <Col xl="12" lg="12" md="12" sm="12">
                <div className="itemImgNumber itemImgNumber1">
                  <img
                      src={imgNumber1}
                      alt=""
                      className="imgNumber imgNumber1"
                  />
                  <p className="pDevelopmentProcess">
                    <b>Концепція рішення та визначення проблеми:</b>
                    <br/>- Співпраця з клієнтом для визначення загальної концепції рішення та визначення основних проблем, які потрібно вирішити. Цей етап ляже в основу проекту.
                  </p>
                </div>
                <div className="itemImgNumber itemImgNumber2">
                  <img
                      src={imgNumber2}
                      alt=""
                      className="imgNumber imgNumber2"
                  />
                  <p className="pDevelopmentProcess">
                    <b>Регулярні зустрічі для виведення статусу:</b>
                    <br/>- Проведення щотижневих зустрічей для виведення статусу зі спонсором проекту та ключовими членами робочої групи. Ці зустрічі служать платформою для постійного спілкування та вирівнювання з метою проекту.
                  </p>
                </div>
                <div className="itemImgNumber itemImgNumber3">
                  <img
                      src={imgNumber3}
                      alt=""
                      className="imgNumber imgNumber3"
                  />
                  <p className="pDevelopmentProcess">
                    <b>План дій та узгодження концепцій:</b>
                    <br/>- Розроблення планів дій та узгодження концепцій рішення та макетів. Цей ітераційний процес допомагає створити спільне бачення та розуміння напрямку рішення.
                  </p>
                </div>
                <div className="itemImgNumber itemImgNumber4">
                  <img
                      src={imgNumber4}
                      alt=""
                      className="imgNumber imgNumber4"
                  />
                  <p className="pDevelopmentProcess">
                    <b>Демонстрація прогресу розробки:</b>
                    <br/>- Показ проміжних результатів розробки клієнту та зацікавленим сторонам проекту. Цей процес забезпечує прозорість та дозволяє отримати ранній зворотний зв'язок та внести корективи.
                  </p>
                </div>
                <div className="itemImgNumber itemImgNumber5">
                  <img
                      src={imgNumber5}
                      alt=""
                      className="imgNumber imgNumber5"
                  />
                  <p className="pDevelopmentProcess">
                    <b>Планування масштабованості:</b>
                    <br/>- Обговорення та коригування планів масштабованості для майбутнього рішення. Масштабованість має важливе значення для врахування зростаючого попиту та змін у страховій галузі.
                  </p>
                </div>
              </Col>
            </Row>
            <Row className="wrapRowMobileApp9">
              <Col>
                <h2 className="h2OnlineStore1">Команда</h2>
                <p className="pCustomerProblems tacenter">
                  Розробка проводилася за
                  <br/>
                  Agile методологією
                </p>
              </Col>
            </Row>
            <Row className="wrapRowMobileApp10">
              <Col xl="3" lg="4" md="6" sm="12" className="col-team col-team1">
                <h2 className="p-team p-team1">Керівник проекту</h2>
              </Col>
              <Col xl="3" lg="4" md="6" sm="12" className="col-team col-team2">
                <h2 className="p-team p-team2">Бізнес-аналітик</h2>
              </Col>
              <Col xl="3" lg="4" md="6" sm="12" className="col-team col-team3">
                <h2 className="p-team p-team3">Бекенд Розробник</h2>
              </Col>
              <Col xl="3" lg="4" md="6" sm="12" className="col-team col-team4">
                <h2 className="p-team p-team4">Мобільний розробник</h2>
              </Col>
              <Col xl={{ span: 3, offset: 3 }} lg="4" md="6" sm="12" className="col-team col-team5">
                <h2 className="p-team p-team5">Інженер з якості</h2>
              </Col>
              <Col xl="3" lg="4" md="6" sm="12" className="col-team col-team6">
                <h2 className="p-team p-team6">Дизайнер</h2>
              </Col>
            </Row>
            <Row className="wrapRowMobileApp11">
              <Col>
                <h2 className="h2OnlineStore1">РЕЗУЛЬТАТИ</h2>
              </Col>
            </Row>
            <Row className="wrapRowMobileApp12">
              <Col xl="6" lg="6" md="12" sm="12">
                <p className="pOnlineStore1">
                  Розробка мобільного додатка тривала три місяці, під час яких команда розробників успішно створила додаток, який задовольнив всі конкретні нашого клієнта.<br/>
                  <br/>
                  Мобільний додаток дав можливість клієнтам:
                  <br/>
                  - Управляти страховими питаннями та вирішувати їх без необхідності відвідувати офіс страхової компанії або використовувати комп'ютер.
                  <br/>
                  - Безперешкодно керувати своїми страховими справами через мобільні телефони, що надавало зручність управління в дорозі на роботу або під час подорожі.
                  <br/><br/>
                  Після завершення початкової фази розробки та впровадження мобільного додатка були заплановані подальші етапи розвитку проекту, що свідчить про постійні зусилля по покращенню функціональності додатка та врахуванню змінних потреб клієнта та його споживачів. Це позначило початок шляху до постійного вдосконалення та інновацій у страховій галузі.
                </p>
              </Col>
              <Col xl="6" lg="6" md="12" sm="12">
                <img
                    src={mobileapp5WD}
                    alt=""
                    className="imgResultsProduct1"
                />
              </Col>
            </Row>
            <Row className="wrapRowDevelopmentProcessText">
              <Col xl="12" lg="12" md="12" sm="12">
                <h2 className="h2DevelopmentProcess">ВИСНОВОК</h2>
              </Col>
            </Row>
            <Row className="wrapRowConclusion">
              <Col xl="6" lg="6" md="12" sm="12">
                <div className="wrapConclusionText">
                  <p className="pConclusion">
                    Цей результат є переконливим прикладом того, як навіть під час таких викликів як карантин, запуск нових рішень може ефективно допомагати страховим компаніям залучати нових клієнтів. Особливо варто відзначити, що це рішення має додаткову перевагу у тому, що воно дозволяє людям без попереднього досвіду в страхуванні генерувати додатковий дохід.
                    <br/>Це підкреслює цінність інновацій та адаптивності для трансформації взаємодії з клієнтами та бізнес-операцій.
                  </p>
                  <a href="/ua/contact" className="btn buttonOne">Зв'язатися</a>
                </div>
              </Col>
              <Col xl="6" lg="6" md="12" sm="12">
                <img src={imgConclusion} alt="" className="imgConclusion" />
              </Col>
            </Row>
          </div>
        </Container>
      </div>

  );
}

export default MobileApp;
